import { useState, useEffect, useCallback } from "react";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { Link } from "react-router-dom";

import Table from "../../../components/common/Table";
import Pagination from "../../../components/common/Pagination";
import Toaster from "../../../components/common/Toaster";

import complianceService from "../../../services/complianceService";

const CorsTable = ({ data, columns, tableOptions, setData, onChange }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const handleSort = (sort_column) => {
    const options = { ...tableOptions };
    options.sort_column = sort_column;
    onChange(options);
  };

  const handlePageChange = (page) => {
    const options = { ...tableOptions };
    options.current_page = page;
    onChange(options);
  };

  const fetchData = useCallback(
    async (mounted) => {
      try {
        setIsLoading(true);

        const response = await complianceService.getCORsAsync(tableOptions);
        const { result, page, total_count } = response;

        const items = result.map((item) => {
          item["is_main_branch"] =
            item.ocn && item.is_main_branch ? (
              <span
                title="Main"
                className="text-white bg-blue-400 px-1 text-xs rounded"
              >
                M
              </span>
            ) : (
              item.ocn &&
              !item.is_main_branch && (
                <span
                  title="Branch"
                  className="text-white bg-gray-400 px-1 text-xs rounded"
                >
                  B
                </span>
              )
            );

          const status =
            item.status === 1
              ? { title: "Active", color: "bg-green-500" }
              : { title: "Inactive", color: "bg-gray-400" };

          let ocn = (
            <div className="flex items-center">
              <span
                title={status.title}
                className={`h-2 w-2 rounded ${status.color} `}
              ></span>
              <div className="ml-4">
                <Link
                  className="text-sm text-gray-500 hover:text-blue-500"
                  to={`/certificate-of-registrations/${item.certificate_of_registration_id}`}
                >
                  {item.ocn}
                </Link>
                <div className="text-xs mt-1">{item.rdo}</div>
              </div>
            </div>
          );

          if (!item.ocn) {
            ocn = (
              <div className="flex items-center">
                <span
                  title="Not available"
                  className="h-2 w-2 bg-red-400 rounded"
                ></span>
                <div className="ml-4">
                  <p className="text-sm text-gray-500">Not available</p>
                </div>
              </div>
            );
          }

          item["ocn"] = ocn;

          if (item.income_tax) {
            item["income_tax"] = (
              <IoCheckmarkCircleOutline className="text-green-500" />
            );
          }

          if (item.percentage_tax) {
            item["percentage_tax"] = (
              <IoCheckmarkCircleOutline className="text-green-500" />
            );
          }

          if (item.expanded_withholding_tax) {
            item["expanded_withholding_tax"] = (
              <IoCheckmarkCircleOutline className="text-green-500" />
            );
          }

          return item;
        });

        if (mounted) {
          setData(items);
          setCurrentPage(page);
          setTotalCount(total_count);
          setIsLoading(false);
        }
      } catch (ex) {
        Toaster.Error("Something went wrong.");
        setIsLoading(false);
      }
    },
    [tableOptions, setData]
  );

  useEffect(() => {
    let mounted = true;

    fetchData(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchData]);

  return (
    <div className="mt-10 overflow-auto">
      <Table
        data={data}
        columns={columns}
        sortColumn={tableOptions.sort_column}
        onSort={handleSort}
        isLoading={isLoading}
      />
      <Pagination
        itemsCount={totalCount}
        currentPage={currentPage}
        pageSize={tableOptions.page_size}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default CorsTable;
